/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CancelAction from './CancelAction/index'
import DeleteAction from './DeleteAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content/Display/Delete/Content/Actions"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Actions.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-AjnkD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bc-2-AjnkD': dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
{children}
</React.Fragment>)
}